import PriceMatrixEditor from "./PriceMatrixEditor";

export default PriceMatrixEditor;



// WEBPACK FOOTER //
// ./src/components/Pricebook/PriceMatrixEditor/index.js